// @flow

import { UPDATE_IMPORTS } from "../actions"

export default ( state: any = {}, action: any ) => {
  switch ( action.type ) {
  case UPDATE_IMPORTS:
    return {
      importList: action.imports,
    }
  default:
    return state
  }
}





// WEBPACK FOOTER //
// ./src/reducers/imports.jsx